import BaseVue from '@/base/BaseVue';

export default class Page404 extends BaseVue {

}
